// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiVersion: '2.1',
    localBackend: false,
    apiUrl: 'https://app.homecare-route-planner.stage.visma.com/api',
    authorityServer: 'https://connect.identity.stagaws.visma.com',
    redirectUri: 'https://app.homecare-route-planner.dev.visma.com/signin-callback',
    postLogoutRedirectUri: 'https://app.homecare-route-planner.dev.visma.com/signout-callback',
    silentRedirectUrl: 'https://app.homecare-route-planner.dev.visma.com/silent-renew-callback.html',
    clientId: 'flyt-route-planner-spa',
    apiScope: 'flyt-route-planner-api-dev:read flyt-route-planner-api-dev:write email',
    survicateWorkspaceKey: "f8c8523473f342b35a9773bf0f2cc71e",
    survicateSurveyId: "5b9cbe1f5ff1478e"
};
